import { isFedRamp } from '@atlassian/atl-context';

export function isMessagingEnabled(): boolean {
	return !isFedRamp();
}
